module.exports = __webpack_public_path__ + "static/media/freedomLogo.dcc377b9.png";